export default {
  incorrectQuery: 'Query is incorrect',
  commandSuccess: 'OK',
  commandFail: 'Command error: ',
  readModelFail: 'Read model query error: ',
  viewModelFail: 'View model query error: ',
  viewModelOnlyOnDemand: 'The aggregateIds field is required',
}
